import styled from "styled-components";

export const LiAlignSkill = styled.li`

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    text-align: start;
    align-items: center;

    font-size: 11px;

    /* background-color: #FFFFFF; */

    width: 150px;

    height: 70px;

    div{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    }

    .titleSpan{

        color: black;
        font-size: 14px;
        margin: 0;
        font-weight: 500;
        
    }

    p{  
        border-radius: 3px;
        padding: 3px;
        background: #00A2FF;
        color: #FFFFFF;
        margin: 0;
    }

    span{
        color: #00A2FF;

        margin-right: 5px;

        -webkit-transition: 0.3s ease-out;
        -moz-transition: 0.3s ease-out;
        -o-transition: 0.3s ease-out;
        transition: 0.3s ease-out;
    }

`